'use client'

import { ProductSelectionProvider } from '@/contexts/ProductSelectionContext'

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ProductSelectionProvider>
      {children}
    </ProductSelectionProvider>
  )
}

